import React, { useState, useEffect } from 'react'
import getClients from './users/getClients'
import { getModel } from '../data/Model'
import { getApiPath } from '../data/api'
import SelectDateComponent from './uploadReport/selectDate'
import Button from '../generic/Button'
import GenericInput from '../generic/Input'
import MaterialInput from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'

function PartnerCard({ partnerData }) {
	return (
		<React.Fragment>
			<h2 style={{ display: 'inline' }}>{partnerData.name}</h2>
			<p
				style={{
					display: 'inline',
					marginLeft: '10px',
					fontVariant: 'small-caps',
					fontSize: 'larger',
				}}
			>
				({partnerData.short_name})
			</p>
		</React.Fragment>
	)
}

function UploadReport() {
	const [partnerNameInput, setPartnerNameInput] = useState('')
	const [selectedPartner, setSelectedPartner] = useState({})
	const [mainClients, setMainClients] = useState([])
	const [foundClients, setFoundClients] = useState([])
	const [uploadedReport, setUploadedReport] = useState([])
	const [selectedYear, setSelectedYear] = useState('')
	const [selectedMonth, setSelectedMonth] = useState('')
	const [fileInputKey, setFileInputKey] = useState(Date.now())
	const [message, setMessage] = useState({
		text: '',
		type: '',
	})

	useEffect(() => {
		const fetchClients = async () => {
			await getClients()
			setMainClients(getModel().clients.mainClients)
		}

		fetchClients()
	}, [])

	const searchForPartner = () => {
		const foundNames = mainClients.filter(
			(client) =>
				client.name.toLowerCase().includes(partnerNameInput.toLowerCase()) ||
				client.short_name.toLowerCase().includes(partnerNameInput.toLowerCase())
		)

		setFoundClients(foundNames)
	}

	const handleChange = (event) => {
		const files = Array.from(event.target.files)
		setUploadedReport(files)
		setMessage({ text: '', type: '' })
	}

	const handleSubmit = async (event) => {
		event.preventDefault()

		if (
			!selectedPartner.client_id ||
			!selectedYear ||
			!selectedMonth ||
			uploadedReport.length === 0
		) {
			setMessage({ text: 'Please fill in all fields', type: 'error' })
			return
		}

		const formData = new FormData()

		uploadedReport.forEach((file) => {
			formData.append('files', file)
		})
		formData.append('clientId', selectedPartner.client_id)
		formData.append('year', selectedYear)
		formData.append('month', selectedMonth)

		try {
			const response = await fetch(getApiPath(`/reports/upload`), {
				method: 'POST',
				body: formData,
				headers: {
					'X-Copyright-Agent-Auth-Token': getModel().auth_token,
				},
			})

			if (response.status === 200) {
				setMessage({ text: 'Upload successful.', type: 'info' })
				resetValues()
			} else if (response.status === 400) {
				setMessage({ text: 'File is wrongly formatted: misplaced headers', type: 'error' })
			}
		} catch (error) {
			setMessage({ text: `Upload failed: ${error.message}`, type: 'error' })
		}
	}

	const handlePartnerSelection = (client) => {
		setSelectedPartner(client)
		setMessage({ text: '', type: '' })
	}

	const resetValues = () => {
		setUploadedReport([])
		setFileInputKey(Date.now())
	}

	const updateDateSelection = (year, month) => {
		setSelectedYear(year)
		setSelectedMonth(month)
		setMessage({ text: '', type: '' })
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
			<div style={{ display: 'flex', flexDirection: 'row', width: '60%' }}>
				<div id='searching' className='container'>
					<div className='col-md-8'>
						<h1 style={{ marginTop: '30px', marginBottom: '20px' }}>
							Search for partner
						</h1>
						<hr />
						<div className='search' style={{ marginBottom: '25px' }}>
							<MaterialInput
								className='input'
								id='adornment-password'
								type='text'
								value={partnerNameInput}
								onChange={(e) => setPartnerNameInput(e.target.value)}
								onKeyDown={(e) => {
									if (e.key === 'Enter') searchForPartner()
								}}
								endAdornment={
									<InputAdornment position='end'>
										<Button className='btn' onClick={searchForPartner}>
											Search
										</Button>
									</InputAdornment>
								}
							/>
						</div>
					</div>
					{foundClients.length !== 0 ? (
						<React.Fragment>
							{foundClients.map((client, index) => (
								<div
									key={index}
									className='result-no-border t-m-bottom'
									style={{
										display: 'flex',
										alignItems: 'center',
										height: '50px',
										backgroundColor:
											client.client_id === selectedPartner.client_id
												? 'lightgrey'
												: '',
									}}
									onClick={() => handlePartnerSelection(client)}
								>
									<PartnerCard partnerData={client} />
								</div>
							))}
						</React.Fragment>
					) : (
						<h3 className='t-m-bottom'>No partner name found.</h3>
					)}
				</div>
				<div id='search-results' className='container'>
					<h1 style={{ marginTop: '30px', marginBottom: '20px' }}>Upload</h1>
					<hr />
					{selectedPartner.name ? (
						<div>
							<div>
								<PartnerCard partnerData={selectedPartner} />
							</div>
							<br />
							<SelectDateComponent
								updateDateSelection={updateDateSelection}
								selectedYear={selectedYear}
								selectedMonth={selectedMonth}
							/>
							<GenericInput
								style={{ height: '65px' }}
								key={fileInputKey}
								onChange={handleChange}
								type='file'
								multiple
							/>
							{uploadedReport.length !== 0 ? (
								<div>
									<h3>Files to upload:</h3>
									<ul style={{ margin: '10px 0 20px 20px' }}>
										{uploadedReport.map((file, index) => (
											<li key={index}>{file.name}</li>
										))}
									</ul>
								</div>
							) : null}
							{message.text !== '' ? (
								<div
									style={{
										color: message.type === 'error' ? 'red' : 'blue',
										margin: '20px 0 10px 0',
									}}
								>
									<h3>{message.text}</h3>
								</div>
							) : null}
							<Button onClick={handleSubmit}>Submit</Button>
						</div>
					) : (
						<p>No partner selected</p>
					)}
				</div>
			</div>
		</div>
	)
}

export default UploadReport
